var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencilAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5832 4.58242H5.99984C5.51361 4.58242 5.04729 4.77558 4.70347 5.1194C4.35966 5.46321 4.1665 5.92953 4.1665 6.41576V16.4991C4.1665 16.9853 4.35966 17.4516 4.70347 17.7955C5.04729 18.1393 5.51361 18.3324 5.99984 18.3324H16.0832C16.5694 18.3324 17.0357 18.1393 17.3795 17.7955C17.7233 17.4516 17.9165 16.9853 17.9165 16.4991V11.9158M16.6203 3.28626C16.7895 3.11116 16.9918 2.97149 17.2154 2.8754C17.4391 2.77932 17.6797 2.72875 17.9231 2.72663C18.1665 2.72452 18.4079 2.7709 18.6333 2.86308C18.8586 2.95527 19.0633 3.0914 19.2354 3.26353C19.4075 3.43567 19.5437 3.64037 19.6358 3.86568C19.728 4.09099 19.7744 4.3324 19.7723 4.57583C19.7702 4.81926 19.7196 5.05983 19.6235 5.2835C19.5274 5.50717 19.3878 5.70947 19.2127 5.87859L11.3422 13.7491H8.74984V11.1568L16.6203 3.28626Z",
    stroke: "#1462B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencilAlt);
export default __webpack_public_path__ + "static/media/ic_pencil-alt.76e20ae936d81ca07f3f7958ff02099f.svg";
export { ForwardRef as ReactComponent };